import React from "react";

import { Check } from "icons";

export const ASSOCIATE_REFERENCE_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "60%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const ASSOCIATE_REFERENCE_ROWS = [
  {
    id: 1,
    name: "Sample 1",
    description: "Sample Reference Source 1 description",
  },
  {
    id: 2,
    name: "Sample 2",
    description: "Sample Reference Source 2 description",
  },
];
